const POST = "POST";
const UPDATE = "PUT";
const DELETE = "DELETE";
const GET = "GET";
const PATCH = "PATCH";
const PUT = "PUT";

export { DELETE, GET, PATCH, POST, PUT, UPDATE };

